import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M9.25 19a.75.75 0 01.75-.75h10.25a.75.75 0 010 1.5H10a.75.75 0 01-.75-.75zM6.605 16.5a.75.75 0 01.75.75V19a.75.75 0 01-1.5 0v-1.75a.75.75 0 01.75-.75zM6.605 4.5a.75.75 0 01.75.75V7a.75.75 0 11-1.5 0V5.25a.75.75 0 01.75-.75z",
      "clip-rule": "evenodd"
    }),
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M2.965 9.51c0-1.907 1.753-3.208 3.707-3.208 1.925 0 3.449 1.143 3.746 2.456a.75.75 0 11-1.464.33c-.103-.457-.865-1.286-2.282-1.286-1.39 0-2.207.87-2.207 1.707 0 .257.06.428.145.558.09.138.233.272.456.404.45.267 1.061.44 1.816.654l.138.04c.755.215 1.655.48 2.356.97.76.532 1.289 1.33 1.289 2.503 0 .968-.578 1.772-1.302 2.302a4.622 4.622 0 01-2.691.862c-1.995 0-3.446-1.237-3.888-2.655a.75.75 0 111.432-.447c.244.782 1.107 1.602 2.456 1.602.678 0 1.333-.227 1.805-.573.48-.35.688-.753.688-1.091 0-.634-.247-.992-.65-1.274-.46-.323-1.111-.53-1.906-.757l-.19-.053c-.691-.196-1.49-.421-2.118-.793a2.814 2.814 0 01-.95-.877 2.476 2.476 0 01-.386-1.375z",
      "clip-rule": "evenodd"
    })
  ]))
}